import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-box" }
const _hoisted_2 = { class: "category-box" }
const _hoisted_3 = { class: "description-box" }
const _hoisted_4 = {
  class: "label",
  for: "description-textarea"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "height" }

import { useI18n } from 'vue-i18n'
import { formatNumber } from '@/utils/math'
import DropdownStandard, { optionType } from '@/design-system/molecules/DropdownStandard.vue'
import TextFieldStandard from '@/design-system/atoms/TextFieldStandard.vue'

interface Props {
  name: string
  description: string
  rh2000String: string
  estimatedHeight: number | null
  categoryOptions: optionType[]
  subCategoryOptions: optionType[]
  title: string
  subCategoryTitle: string
  isOutdoorPoi: boolean
  isPlanviewShowing: boolean
  editMode: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralSectionAssets',
  props: {
    name: {},
    description: {},
    rh2000String: {},
    estimatedHeight: {},
    categoryOptions: {},
    subCategoryOptions: {},
    title: {},
    subCategoryTitle: {},
    isOutdoorPoi: { type: Boolean },
    isPlanviewShowing: { type: Boolean },
    editMode: { type: Boolean }
  },
  emits: ["updateName", "updateDescription", "updateRh2000String", "updateEstimatedHeight", "selectCategory", "selectSubCategory"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const { t } = useI18n()

function onNameInput(value: string | number) {
  emit('updateName', String(value))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(DropdownStandard, {
          class: "dropdown",
          disabled: false,
          hasSearch: true,
          title: _ctx.title,
          searchType: _unref(t)('general__text__category').toLocaleLowerCase(),
          label: _unref(t)('general__text__category'),
          options: _ctx.categoryOptions,
          required: true,
          onSelect: _cache[0] || (_cache[0] = (id) => emit('selectCategory', id))
        }, null, 8, ["title", "searchType", "label", "options"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(DropdownStandard, {
          class: "dropdown",
          disabled: !_ctx.subCategoryOptions.length,
          hasSearch: true,
          title: _ctx.subCategoryTitle,
          required: true,
          searchType: _unref(t)('general__text__sub-category').toLocaleLowerCase(),
          label: _unref(t)('general__text__sub-category'),
          options: _ctx.subCategoryOptions,
          onSelect: _cache[1] || (_cache[1] = (id) => emit('selectSubCategory', id))
        }, null, 8, ["disabled", "title", "searchType", "label", "options"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(TextFieldStandard, {
        class: "textfield",
        hideIconX: true,
        label: _unref(t)('general__text__name'),
        prefilledText: _ctx.name,
        onEmitInput: onNameInput
      }, null, 8, ["label", "prefilledText"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('general__text__description')), 1),
      _createElementVNode("textarea", {
        id: "description-textarea",
        value: _ctx.description,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (emit('updateDescription', ($event.target as HTMLTextAreaElement).value))),
        class: "textarea"
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(TextFieldStandard, {
        class: "dropdown",
        infoText: 
          _ctx.isOutdoorPoi
            ? _unref(t)('info__poi-height-rh2000-realestate')
            : _unref(t)('info__poi-height-rh2000-level')
        ,
        label: _unref(t)('general__text__height-in-RH'),
        hideIconX: true,
        prefilledText: _ctx.rh2000String,
        onEmitInput: _cache[3] || (_cache[3] = (val) => emit('updateRh2000String', val))
      }, null, 8, ["infoText", "label", "prefilledText"]),
      _createVNode(TextFieldStandard, {
        class: "dropdown",
        label: 
          _ctx.isPlanviewShowing
            ? _unref(t)('general__text__estimated-height-from-floor-m')
            : _unref(t)('general__text__estimated-height-from-ground-m')
        ,
        infoText: _unref(t)('info__poi-estimated-height'),
        hideIconX: true,
        prefilledText: 
          _ctx.estimatedHeight || _ctx.estimatedHeight === 0 ? _unref(formatNumber)(_ctx.estimatedHeight, 2) : ''
        ,
        onEmitInput: _cache[4] || (_cache[4] = (val) => emit('updateEstimatedHeight', val))
      }, null, 8, ["label", "infoText", "prefilledText"])
    ])
  ]))
}
}

})